import {
  fetchRecommendationCards,
  initCrossSellingSlider
} from "./chunk-QK33G7X6.js";
import "./chunk-BXT5NPGI.js";
import {
  SnippetElement,
  defineElement,
  on,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/pb-common-cross-selling/pb-common-cross-selling.ts
var PbCommonCrossSelling = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.expanded = false;
    this.initialized = false;
  }
  connectedCallback() {
    if (this.initialized)
      return;
    this.initialized = true;
    const url = this.dataset.recommendationsUrl;
    if (url) {
      this.load(url);
    } else {
      this.setup(false);
    }
  }
  load(url) {
    return __async(this, null, function* () {
      var _a, _b;
      const limit = parseInt((_a = this.dataset.limit) != null ? _a : "") || 8;
      const cards = yield fetchRecommendationCards(url, limit, ["[data-desktop-cards]", "[data-mobile-cards]"]);
      if (!cards || !this.rows || !this.slides)
        return;
      cards[0].forEach((card) => this.rows.appendChild(document.importNode(card, true)));
      cards[1].forEach((card) => this.slides.appendChild(document.importNode(card, true)));
      (_b = this.content) == null ? void 0 : _b.classList.remove("hidden");
      this.setup(true);
    });
  }
  setup(refreshSwiper) {
    this.applyCollapse();
    initCrossSellingSlider(this, this.progressFill, refreshSwiper);
  }
  get collapsibleCards() {
    var _a, _b;
    return Array.from((_b = (_a = this.rows) == null ? void 0 : _a.children) != null ? _b : []);
  }
  get collapsedCount() {
    var _a;
    return parseInt((_a = this.dataset.collapsedCount) != null ? _a : "") || 4;
  }
  applyCollapse() {
    if (this.collapsibleCards.length <= this.collapsedCount || !this.showMoreButton)
      return;
    this.showMoreButton.classList.remove("hidden");
    this.updateCollapse();
  }
  handleClick(_, evt) {
    var _a, _b;
    if (!((_b = (_a = evt.target).closest) == null ? void 0 : _b.call(_a, "[data-show-more]")))
      return;
    this.expanded = !this.expanded;
    this.updateCollapse();
  }
  updateCollapse() {
    var _a;
    this.collapsibleCards.forEach((card, index) => {
      card.classList.toggle("hidden", !this.expanded && index >= this.collapsedCount);
    });
    const button = this.showMoreButton;
    if (!button)
      return;
    button.textContent = (_a = this.expanded ? button.dataset.lessLabel : button.dataset.moreLabel) != null ? _a : "";
    button.setAttribute("aria-expanded", String(this.expanded));
  }
};
__decorateClass([
  query("[data-content]")
], PbCommonCrossSelling.prototype, "content", 2);
__decorateClass([
  query("[data-rows]")
], PbCommonCrossSelling.prototype, "rows", 2);
__decorateClass([
  query("[data-slides]")
], PbCommonCrossSelling.prototype, "slides", 2);
__decorateClass([
  query("[data-show-more]")
], PbCommonCrossSelling.prototype, "showMoreButton", 2);
__decorateClass([
  query("[data-progress-fill]")
], PbCommonCrossSelling.prototype, "progressFill", 2);
__decorateClass([
  on("click")
], PbCommonCrossSelling.prototype, "handleClick", 1);
PbCommonCrossSelling = __decorateClass([
  defineElement("pb-common-cross-selling")
], PbCommonCrossSelling);
export {
  PbCommonCrossSelling
};
